export default __webpack_public_path__ + "static/media/regendouche.2428fd38.jpg";